module.exports = __webpack_public_path__ + "static/flags/IZ-7009118bf178273357e90f68feb66db0.gif";